import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { isLoggedIn } from "@/lib/auth-client";
import { MyEvents } from "@/components/profile/MyEvents";

/**
 * /my-events — everything the user has entered, in one place.
 * Current events (upcoming/open/locked) with live score + rank, then
 * completed events below. Reached from the tab bar "My Events" item.
 */
export default function MyEventsPage() {
  const router = useRouter();

  useEffect(() => {
    if (!isLoggedIn()) router.replace("/login?redirect=/my-events");
  }, [router]);

  return (
    <div className="min-h-screen bg-surface">
      <div className="ornamental-rule max-w-5xl mx-auto px-4 sm:px-6 pt-6 sm:pt-8" />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="mb-6 sm:mb-8">
          <span className="text-gold text-[10px] sm:text-xs font-bold tracking-[0.2em] uppercase mb-3 sm:mb-4 block">
            My Events
          </span>
          <h1 className="text-2xl sm:text-3xl font-serif font-bold text-cream mb-2">
            Your Arenas
          </h1>
          <p className="text-sm sm:text-base text-warm-gray">
            Every event you&apos;ve entered — live scores first, finished runs below.
          </p>
        </div>
        <MyEvents />
      </main>
    </div>
  );
}
